/* Responsibility: Create the namespaces for FINN.travel */
/* eslint-disable */
window.FINN = window.FINN || {};
window.FINN.travel = FINN.travel || {};
window.FINN.travel.validity = {
    validations: {},
};
window.FINN.travel.polling = {};
window.FINN.travel.pp = window.FINN.travel.pp || {};
window.FINN.travel.currency = {};
window.FINN.travel.contextPath = window.FINN.travel.contextPath || '';
